import { render, staticRenderFns } from "./PesquisaItensAdesaoView.vue?vue&type=template&id=3256699d&scoped=true"
import script from "./PesquisaItensAdesaoView.vue?vue&type=script&lang=js"
export * from "./PesquisaItensAdesaoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256699d",
  null
  
)

export default component.exports